import { useEffect, useState } from "react";
import { deleteCommentFromTask } from "../../redux/actions/TodoManipulation/deleteCommentAction";
import { useDispatch } from 'react-redux';





const Comments = (props) => {

    const dispatch = useDispatch();
    const {
        comments,
        parentId,
        handleAddComment,
        handleCommentDisplay,
        isAddCommentsShowing,
        handleAddCommentToggle
    } = props;


    const [disableButtons, setDisableButtons] = useState(true);
    const [content, setContent] = useState("");

    const handleAddCommentChange = (event) => {
        if (event.key === 'Enter') {
            const title = event.target.value;
            if (title !== "") {
                handleAddComment(title);
                setContent("");
            }
        }
        else if (event.key === 'Escape') {
            setContent("");
            setIsAddCommentsShowing(false);
        }
        else {
            if (event.key !== 'Enter') {
                setContent(event.target.value);
            }
        }

        if (event) {
            setDisableButtons(false);
        } else {
            setDisableButtons(true);
        }

    }

    async function deleteComment(commentId) {
        const json = {
            id: props.parentId,
            CommentId: commentId
        }
        await dispatch(deleteCommentFromTask(json));
    };


    return (
        <>
            {comments.map((comment, index) => (
                <div key={index} id={comment.id} className="gt-comment">
                    <p>{comment.text}</p>
                    <div className="gt-context-menu-activator gt-context-menu-activator--top-right">
                        <button
                            className="gw-icon-button gw-icon-button--icon"
                            aria-label="Delete Comment" // More descriptive aria-label
                            onClick={() => deleteComment(comment.id)} // Dispatch delete action
                        >
                            <i className="gw-icon-button__icon gw-button__icon--delete"></i>
                        </button>
                    </div>
                </div>
            ))}

            {!isAddCommentsShowing ? (
                <button
                    className="gt-task-overview__add-button"
                    onClick={() => handleAddCommentToggle()}
                >
                    <svg xmlns="http://www.w3.org/2000/svg">
                        <use xlinkHref="#globaltasks-svg-add"></use>
                    </svg>
                    Add comment
                </button>
            ) : (
                <div className="gt-add-task">
                    <div
                        className="gt-add-task__title"
                    >
                        <textarea
                            className="add-task-title add-comment-title"
                            type="text"
                            value={content}
                            onChange={handleAddCommentChange}
                            placeholder="Add a new comment"
                            onKeyDown={handleAddCommentChange}
                            autoFocus={true}
                            wrap="soft"
                        />
                    </div>

                    <div className="gt-add-task__controls">

                        <button
                            className="gw-button gw-button--s1"
                            onClick={() => {
                                setContent("");
                                setDisableButtons(true);
                                handleAddCommentToggle();
                                handleCommentDisplay();
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            className="gw-button gw-button--s1 gw-button--primary"
                            disabled={disableButtons}
                            onClick={() => {

                                if (content.trim() !== "") {
                                    handleAddComment(content);
                                    setDisableButtons(true);
                                    setContent("");
                                }
                            }}
                        >
                            Save
                        </button>
                    </div>
                </div>
            )}

        </>
    )
}

export default Comments;